import { useSearchParams } from "react-router-dom"
import MappingsTab from "./components/MappingsTab"
import { mappingTypes } from "../../constants/illustrationMappings"

const IllustrationMappings = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = mappingTypes[searchParams.get("tab")]
    ? searchParams.get("tab")
    : mappingTypes.pathology.key

  const setTab = (key) => setSearchParams({ tab: key })

  return (
    <>
      <div className="px-4 py-2 flex justify-between items-center mt-2">
        <h1 className="text-2xl font-bold">Manage Mappings</h1>
      </div>
      <div className="flex gap-1 px-4 pt-3 border-b border-gray-200">
        {Object.values(mappingTypes).map((t) => (
          <button
            key={t.key}
            className={`flex items-center gap-2 px-4 pb-3 pt-2 text-sm font-semibold border-b-[3px] transition-colors ${
              tab === t.key
                ? "text-primary border-secondary"
                : "text-gray-500 border-transparent"
            }`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <MappingsTab key={tab} mappingType={mappingTypes[tab]} />
    </>
  )
}

export default IllustrationMappings
